module.exports = __webpack_public_path__ + "img/ic_burger_athleten.bdf6d805.svg";